module.exports = __webpack_public_path__ + "assets/icons/calendar.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/dateTime/calendar.png
// module id = ./src/styles/icons/dateTime/calendar.png
// module chunks = 0